function formater (val){
  let confirmedValue = isNaN(val) ? val : Number(val)
  let formatter =  new Intl.NumberFormat('en-US', {
    style: 'decimal',
    useGrouping: true
  });

  return formatter.format(confirmedValue)
}

  export default formater